module.exports = __webpack_public_path__ + "img/9.ac2d1da1.jpg";